import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ApiService } from '../../services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'pos-app-lib-customer-order-salesperson-selector',
    templateUrl: './customer-order-salesperson.component.html',
    styleUrls: ['./customer-order-salesperson.component.scss'],
    standalone: false
})
export class CustomerOrderSalesPersonSelector implements OnInit, OnDestroy {
  @Input() currentSalesPerson: string;
  @Input() orderNumber: number;
  @Input() orderType: string;
  @Input() JDEOrderType: string;
  @Input() JDECompany: string;
  @Input() isClickAndCollect: boolean = false;
  @Input() isEcomQuote: boolean = false;


  @Input() salesPeopleList: any;
  @Output() reloadData = new EventEmitter();
  @Output() closeActiveModal = new EventEmitter();
  selectedSalesPerson: string;
  formValid: boolean;
  salesPersonSearchForm: UntypedFormGroup;
  unSubscribe$ = new Subject<void>();
  loading: boolean = false;
  constructor(private apiService: ApiService, private toastr: ToastrService, private router: Router) {}

  ngOnInit() {}

  handleSelectedUser(user) {
    this.selectedSalesPerson = user?.userEmail;
    if (this.selectedSalesPerson) {
      this.formValid = true;
    } else {
      this.formValid = false;
    }
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  handleCloseModel() {
    this.closeActiveModal.emit();
  }
  updateSalsePerson() {
    if (this.isClickAndCollect || this.isEcomQuote) {
      this.acknowledgeClickAndCollectOrder();
    } else {
      this.updateOwnerOfSavedOrder();
    }
  }

  updateOwnerOfSavedOrder() {
    this.loading = true;
    this.apiService
      .updateOwnerOfSavedOrder({
        orderNumber: this.orderNumber,
        JDEOrderType: this.JDEOrderType,
        JDECompany: this.JDECompany,
        newOwner: this.selectedSalesPerson,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        if ((res.errorFlag = '0')) {
          this.loading = false;
          this.reloadData.emit();
          this.toastr.success('Salesperson updated successfully');
        } else {
          this.loading = false;
          this.toastr.error(res?.errorMessage);
        }
      }); //
  }

  acknowledgeClickAndCollectOrder() {
    this.loading = true;
    this.apiService
      .acknowledgeEcomOrder({
        orderNumber: this.orderNumber,
        salesperson: this.selectedSalesPerson,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((res) => {
        if (res.errorFlag === '0') {
          this.loading = false;
          if (this.isClickAndCollect) {
            this.toastr.success('Order acknowledged successfully');
            this.reloadData.emit();
          }
          if (this.isEcomQuote) {
            this.closeActiveModal.emit();
            this.toastr.success('Quote acknowledged successfully');
            this.router.navigate([`/pos/orders/${this.orderNumber}`], { queryParams: { continueUrl: 'back' } });
          }
        } else {
          this.loading = false;
          this.toastr.error(res?.ErrorMessage || 'Failed to acknowledge order');
        }
      });
  }
}

